// extracted by mini-css-extract-plugin
module.exports = {"skillsContainer":"SkillsContent_skillsContainer__2zlMM","skillTitle":"SkillsContent_skillTitle__1EnHy","skillDescription":"SkillsContent_skillDescription__CUu9b"};